export const capitalize = (item?: string) => {
  return item?.toLowerCase().replace(/\w\S*/g, w => w.replace(/^\w/, c => c.toUpperCase()));
};
